import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { FederatedIdentityPayload } from "../models/federated-identity.model";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FederatedIdentityService {
  constructor(private http: HttpClient) { } 

  authorize(provider: string, token: string): Promise<FederatedIdentityPayload> {
    return lastValueFrom(this.http
      .post<FederatedIdentityPayload>(`${environment.apiUrl}/federatedIdentity/authorize`, { provider, token }));
  }

}
